// extracted by css-extract-rspack-plugin
export default {"container":"NestedListViewHeader-module__container__WSXhdTQ"};